module.exports = __webpack_public_path__ + "static/media/ingrifo.1decc03b.png";